module.exports = __webpack_public_path__ + "img/minka_ja_mansikat.2deb2f66.jpg";